module.exports = __webpack_public_path__ + "img/StationBatteryLow.b4f7f187.svg";